import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';

export const ContactFormEvents: AnalyticsBrandSettings = {

  contactoAyudaConsultaEnviadaOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const label = data?.componentData?.extraInfo;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'contacto', 'consulta_enviada_ok', label);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  contactoAyudaContactoVentaOnline(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'contacto', 'contacto', 'contacto_venta_online');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  contactoAyudaContactoVentaFisica(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'contacto', 'contacto', 'contacto_venta_fisica');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  contactoAyudaErrorContacto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const field = data?.componentData?.field;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'contacto', 'error_contacto', field);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  contactoAyudaErrorServidorContacto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const error = `cod_${componentData?.errorCode}-desc_${componentData?.errorDescription}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'contacto', 'error_servidor_contacto', error);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  contactoLegalVerPoliticaPrivacidad(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'legal', 'contacto', 'ver_politica_privacidad');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  contactoPerfilUsuarioFidelizacion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'perfil_usuario', 'contacto', 'fidelizacion', 'contacto_whatssap');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

};
